/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import * as React from "react";

export interface IBusinessSignUpLabelProps {
  id: string;
  forId: string;
  className: string;
  text: string;
}

export const SignUpLabel: React.FC<IBusinessSignUpLabelProps> = ({
  id,
  forId,
  className,
  text,
}) => (
  <label id={`${id}_label`} className={`${className}-label`} htmlFor={forId}>
    {text}
  </label>
);

export default SignUpLabel;
